module.exports = __webpack_public_path__ + "img/logo-gob-sep.5305d4f0.svg";